const OjoIcon = () => {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8138 4.45952C12.7047 0.434524 9.31444 0 8.00033 0C6.67512 0 3.26055 0.434762 0.183796 4.46286C0.0637148 4.62005 -0.000505511 4.80775 2.99665e-06 5.00006C0.000511504 5.19237 0.0657237 5.37978 0.186634 5.53643C0.994146 6.58381 3.94186 10 8.00033 10C9.30489 10 12.6769 9.56548 15.8107 5.53976C15.9332 5.3825 15.9994 5.1938 16 5.0001C16.0006 4.8064 15.9354 4.61738 15.8138 4.45952ZM8.00187 7.85714C7.38937 7.85714 6.79062 7.68957 6.28134 7.37563C5.77206 7.06168 5.37512 6.61546 5.14073 6.09338C4.90633 5.57131 4.845 4.99683 4.9645 4.4426C5.08399 3.88837 5.37894 3.37927 5.81205 2.9797C6.24516 2.58012 6.79697 2.308 7.3977 2.19776C7.99844 2.08751 8.62112 2.14409 9.187 2.36034C9.75288 2.57659 10.2365 2.9428 10.5768 3.41266C10.9171 3.88251 11.0988 4.43491 11.0988 5C11.0988 5.75776 10.7725 6.48449 10.1917 7.02031C9.61092 7.55612 8.82322 7.85714 8.00187 7.85714Z"
        fill="#F8F8F8"
      />
      <circle cx="8" cy="5" r="2" fill="#F8F8F8" />
    </svg>
  );
};

export default OjoIcon;
